import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { Toggle } from "../../../../components/superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import ExperienceData from "./ExperienceData";
import { useFormik } from "formik";
import AddedPackages from "../Experiencedashboard/AddedPackages";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { isEmpty } from "lodash";

const ExperienceBooking = ({
  formik,
  expType,
  count,
  ageRestriction,
  ...props
}) => {
  const packageFormik = useFormik({
    initialValues: ExperienceData.packageInitValues,
    validationSchema: ExperienceData.packageValidation
  });


  const [showPackages, setShowPackages] = useState(false);
  const [addAnother, setAddAnother] = useState(true);
  const [error, setError] = useState({});

  const onSave = () => {
    setError({});
    packageFormik.setFieldTouched('name', true)
    packageFormik.setFieldTouched('price', true)
    packageFormik.setFieldTouched('adults', true)
    packageFormik.validateForm()

    if (ageRestriction) {
      let errors = packageFormik.errors;
      delete errors.kids
      packageFormik.setErrors(errors);
    }
    let flag = true;

    if (expType === "CURATED" && formik.values?.totalSeats < packageFormik.values.adults + packageFormik.values.kids) {
      let _error = {
        adults: "Package seats should be less than or equal to Total No of Seats",
        kids: "Package seats should be less than or equal to Total No of Seats"
      }
      setError(_error);
      flag = false;
    }
    if (isEmpty(packageFormik.errors) && packageFormik.values.name && packageFormik.values.price && packageFormik.values.adults && flag) {
      formik.setFieldValue("packages", [
        ...formik.values.packages,
        packageFormik.values,
      ]);
      packageFormik.resetForm();
      setAddAnother(true);
    }
  };

  const onSaveAndAdd = () => {
    setError({});
    packageFormik.setFieldTouched('name', true)
    packageFormik.setFieldTouched('price', true)
    packageFormik.setFieldTouched('adults', true)
    packageFormik.validateForm()
    if (ageRestriction) {
      let errors = packageFormik.errors;
      delete errors.kids
      packageFormik.setErrors(errors);
    }
    let flag = true;

    if (expType === "CURATED" && formik.values?.totalSeats < packageFormik.values.adults + packageFormik.values.kids) {
      let _error = {
        adults: "Package seats should be less than or equal to Total No of Seats",
        kids: "Package seats should be less than or equal to Total No of Seats"
      }
      setError(_error);
      flag = false;
    }
    if (isEmpty(packageFormik.errors) && packageFormik.values.name && packageFormik.values.price && packageFormik.values.adults && flag) {
      formik.setFieldValue("packages", [
        ...formik.values.packages,
        packageFormik.values,
      ]);
      packageFormik.resetForm();
      setAddAnother(true);
      let pkgname = document.getElementById("name");
      pkgname.focus();
    }
  };

  const editPackage = (data) => {
    let filter = formik.values.packages.filter((ele) => ele.name !== data.name);
    formik.setFieldValue("packages", filter);
    packageFormik.setFieldValue("name", data.name);
    packageFormik.setFieldValue("price", data.price);
    packageFormik.setFieldValue("discountedPrice", data.discountedPrice);
    packageFormik.setFieldValue("adults", data.adults);
    packageFormik.setFieldValue("kids", data.kids);
    packageFormik.setFieldValue("desc", data.desc);
    packageFormik.setFieldValue("seatCustomized", data.seatCustomized);
    packageFormik.setFieldValue("status", data.status);
    setAddAnother(true);
  };

  const deletePackage = (data) => {
    let filter = formik.values.packages.filter((ele) => ele.name !== data.name);
    formik.setFieldValue("packages", filter);
  };

  const onPackageStatusChange = (data) => {
    let packages = formik.values.packages;
    let index = packages.findIndex((ele) => ele.name === data.name);
    if (index >= 0) {
      packages[index].status = !packages[index].status;
    }
    formik.setFieldValue("packages", packages);
  };

  useEffect(() => {
    if (formik.errors && formik.errors.adultPrice) {
      let adultpriceElement = document.getElementById("adultPrice");
      if (adultpriceElement) adultpriceElement.focus();
    } else if (
      !ageRestriction &&
      formik.errors &&
      formik.errors.kidsPrice
    ) {
      let kidsElement = document.getElementById("kidsPrice");
      if (kidsElement) kidsElement.focus();
    } else if (formik.errors && formik.errors.totalSeats) {
      let totalseatsElement = document.getElementById("totalSeats");
      if (totalseatsElement) totalseatsElement.focus();
    }
  }, [count]);

  return (
    <React.Fragment>
      <Form>
        <div className="f20-700 text-dark mt-4 mb-5">
          Seating & Pricing Details
        </div>
        <Row className="align-items-center pb-3 pl-3 w-100">
          <Col md={6} xs={6}>
            <div className="f14-700 text-dark">
              Do you provide single seating for this experience?
            </div>
            <div className="f11-400 opacity5">
              Create single adult and kids tickets and prices.
            </div>
          </Col>
          <Col md={6} xs={6}>
            <div className="d-flex align-items-center">
              <div className="f12-400 mr-2">No</div>
              <Toggle
                checked={formik.values.allowSingleBooking}
                toggleFunction={() => {
                  formik.setValues({
                    ...formik.values,
                    "allowSingleBooking":
                      !formik.values.allowSingleBooking,
                    'adultPrice': 0, 'kidsPrice': 0, 'minSeats': 0, "maxSeats": 0, 'ticketDesc': ""
                  });
                  setAddAnother(true);
                }}
              />
              <div className="f12-400 ml-2">Yes</div>
            </div>
          </Col>
        </Row>
        <Row className="py-4">
          <Col md={12} lg={7}>
            <Row>
              {formik.values.allowSingleBooking ?
                <>
                  <Col md={6} xs={6}>
                    <Form.Group className="pb-4">
                      <TextField
                        id="adultPrice"
                        label="Adult Ticket Price*"
                        type="number"
                        maxLength={5}
                        variant="outlined"
                        className={`w-100 ${formik.errors.adultPrice && formik.touched.adultPrice
                          ? "enError"
                          : ""
                          }`}
                        name="adultPrice"
                        onChange={formik.handleChange}
                        value={formik.values.adultPrice}
                        onBlur={formik.handleBlur}
                      />
                      <div className="f11-400 opacity5">
                        Inclusive of all taxes and charges
                      </div>
                      {formik.errors.adultPrice && formik.touched.adultPrice ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.adultPrice}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col md={6} xs={6}>
                    {!ageRestriction ? (
                      <Form.Group className="pb-4">
                        <TextField
                          id="kidsPrice"
                          label="Kids Ticket Price*"
                          type="number"
                          maxLength={5}
                          variant="outlined"
                          className={`w-100 ${formik.errors.kidsPrice && formik.touched.kidsPrice
                            ? "enError"
                            : ""
                            }`}
                          name="kidsPrice"
                          onChange={formik.handleChange}
                          value={formik.values.kidsPrice}
                          onBlur={formik.handleBlur}
                          error={formik.errors.kidsPrice && formik.touched.kidsPrice}
                          isInvalid={formik.errors.kidsPrice && formik.touched.kidsPrice}
                        />
                        <div className="f11-400 opacity5">
                          Inclusive of all taxes and charges
                        </div>
                        {formik.errors.kidsPrice && formik.touched.kidsPrice ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.kidsPrice}
                          </div>
                        ) : null}
                      </Form.Group>
                    ) : (
                      <></>
                    )}
                  </Col>
                  <Col md={6} xs={6}>
                    <Form.Group className="pb-4">
                      <TextField
                        id="minSeats"
                        label="Min seats per booking"
                        type="number"
                        maxLength={5}
                        variant="outlined"
                        className={`w-100 ${formik.errors.minSeats && formik.touched.minSeats
                          ? "enError"
                          : ""
                          }`}
                        name="minSeats"
                        onChange={formik.handleChange}
                        value={formik.values.minSeats}
                        onBlur={formik.handleBlur}
                        error={formik.errors.minSeats && formik.touched.minSeats}
                        isInvalid={formik.errors.minSeats && formik.touched.minSeats}
                      />
                      {formik.errors.minSeats && formik.touched.minSeats ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.minSeats}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col md={6} xs={6}>
                    <Form.Group className="pb-4">
                      <TextField
                        id="maxSeats"
                        label="Max seats per booking"
                        type="number"
                        maxLength={5}
                        variant="outlined"
                        className={`w-100 ${formik.errors.maxSeats && formik.touched.maxSeats
                          ? "enError"
                          : ""
                          }`}
                        name="maxSeats"
                        onChange={formik.handleChange}
                        value={formik.values.maxSeats}
                        onBlur={formik.handleBlur}
                        error={formik.errors.maxSeats && formik.touched.maxSeats}
                        isInvalid={formik.errors.maxSeats && formik.touched.maxSeats}
                      />
                      {formik.errors.maxSeats && formik.touched.maxSeats ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.maxSeats}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </>
                : <></>}
              <Col md={6}>
                <Form.Group className="pb-4">
                  <TextField
                    id="totalSeats"
                    label="Total no of seats available"
                    type="number"
                    maxLength={5}
                    variant="outlined"
                    className={`w-100 ${formik.errors.totalSeats && formik.touched.totalSeats
                      ? "enError"
                      : ""
                      }`}
                    name="totalSeats"
                    onChange={formik.handleChange}
                    value={formik.values.totalSeats}
                    onBlur={formik.handleBlur}
                  />
                  <div className="f11-400 opacity5">
                    Enter total number of available seats for this ticket type
                  </div>
                  {formik.errors.totalSeats && formik.touched.totalSeats ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.totalSeats}
                    </div>
                  ) : null}
                </Form.Group>
              </Col>
              {formik.values.allowSingleBooking ?
                <Col md={12}>
                  <Form.Group className="pb-4">
                    <TextField
                      id="ticketDesc"
                      label="Ticket Description"
                      multiline
                      rows="5"
                      type="text"
                      variant="outlined"
                      className={`w-100 ${formik.errors.ticketDesc && formik.touched.ticketDesc ? "enError" : ""
                        }`}
                      name="ticketDesc"
                      onChange={formik.handleChange}
                      value={formik.values.ticketDesc}
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.errors.ticketDesc && formik.touched.ticketDesc
                          ? formik.errors.ticketDesc
                          : "Max 500 characters"
                      }
                      error={formik.errors.ticketDesc && formik.touched.ticketDesc}
                      isInvalid={
                        formik.errors.ticketDesc && formik.touched.ticketDesc
                      }
                    />
                  </Form.Group>
                </Col>
                : <></>}
              <hr />
              <Row className="align-items-center pb-3 pl-3 w-100">
                <Col md={9} xs={6}>
                  <div className="f14-700 text-dark">
                    Do you provide any package for this experience?
                  </div>
                  <div className="f11-400 opacity5">
                    Create a package with a combination of adult and kids
                    tickets and prices.
                  </div>
                </Col>
                <Col md={3} xs={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-400 mr-2">No</div>
                    <Toggle
                      checked={formik.values.isPackagesProvided}
                      toggleFunction={() => {
                        formik.setFieldValue(
                          "isPackagesProvided",
                          !formik.values.isPackagesProvided
                        );
                        setAddAnother(true);
                      }}
                    />
                    <div className="f12-400 ml-2">Yes</div>
                  </div>
                </Col>
              </Row>
              {formik.values.isPackagesProvided && addAnother && (
                <>
                  <Row>
                    <Col md={12}>
                      <Form.Group className="pb-3">
                        <TextField
                          id="name"
                          label="Package Name"
                          type="text"
                          variant="outlined"
                          className={`w-100  ${packageFormik.errors.name && packageFormik.touched.name ? "enError" : ""
                            }`}
                          name="name"
                          onChange={packageFormik.handleChange}
                          value={packageFormik.values.name}
                          onBlur={packageFormik.handleBlur}
                          helperText={
                            packageFormik.errors.name && packageFormik.touched.name
                              ? packageFormik.errors.name
                              : "Create package as per your choice, eg. birthday party package"
                          }
                          error={packageFormik.errors.name && packageFormik.touched.name}
                          isInvalid={packageFormik.errors.name && packageFormik.touched.name}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} xs={6}>
                      <Form.Group className="pb-3">
                        <TextField
                          id="price"
                          label="Package Price*"
                          type="number"
                          variant="outlined"
                          className={`w-100  ${packageFormik.errors.price && packageFormik.touched.price ? "enError" : ""
                            }`}
                          name="price"
                          onChange={packageFormik.handleChange}
                          value={packageFormik.values.price}
                          onBlur={packageFormik.handleBlur}
                          helperText={
                            packageFormik.errors.price && packageFormik.touched.price
                              ? packageFormik.errors.price
                              : "Inclusive of all taxes and charges"
                          }
                          error={packageFormik.errors.price && packageFormik.touched.price}
                          isInvalid={packageFormik.errors.price && packageFormik.touched.price}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} xs={6}>
                      <Form.Group className="pb-3">
                        <TextField
                          id="discountedPrice"
                          label="Discount Price"
                          type="number"
                          variant="outlined"
                          className={`w-100  ${packageFormik.errors.discountedPrice && packageFormik.touched.discountedPrice ? "enError" : ""
                            }`}
                          name="discountedPrice"
                          onChange={packageFormik.handleChange}
                          value={packageFormik.values.discountedPrice}
                          onBlur={packageFormik.handleBlur}
                          helperText={
                            packageFormik.errors.discountedPrice && packageFormik.touched.discountedPrice
                              ? packageFormik.errors.discountedPrice
                              : "Inclusive of all taxes and charges"
                          }
                          error={packageFormik.errors.discountedPrice && packageFormik.touched.discountedPrice}
                          isInvalid={packageFormik.errors.discountedPrice && packageFormik.touched.discountedPrice}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} xs={6}>
                      <Form.Group className="pb-3">
                        <TextField
                          id="adults"
                          label="No of Adults"
                          type="number"
                          variant="outlined"
                          className={`w-100  ${packageFormik.errors.adults && packageFormik.touched.adults ? "enError" : ""
                            }`}
                          name="adults"
                          onChange={packageFormik.handleChange}
                          value={packageFormik.values.adults}
                          onBlur={packageFormik.handleBlur}
                          helperText={
                            error?.adults ?
                              error?.adults
                              : (packageFormik.errors.adults && packageFormik.touched.adults)
                                ? packageFormik.errors.adults
                                : "Mention the PAX allowed for the package"
                          }
                          error={(packageFormik.errors.adults && packageFormik.touched.adults) || error?.adults}
                          isInvalid={(packageFormik.errors.adults && packageFormik.touched.adults) || error?.adults}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} xs={6}>
                      {!ageRestriction ? (
                        <Form.Group className="pb-3">
                          <TextField
                            id="kids"
                            label="No of Kids"
                            type="number"
                            variant="outlined"
                            className={`w-100  ${packageFormik.errors.kids && packageFormik.touched.kids ? "enError" : ""
                              }`}
                            name="kids"
                            onChange={packageFormik.handleChange}
                            value={packageFormik.values.kids}
                            onBlur={packageFormik.handleBlur}
                            helperText={
                              error?.kids ?
                                error?.kids
                                : (packageFormik.errors.kids && packageFormik.touched.kids)
                                  ? packageFormik.errors.kids
                                  : "Mention the PAX allowed for the package"
                            }
                            error={(packageFormik.errors.kids && packageFormik.touched.kids) || error?.kids}
                            isInvalid={(packageFormik.errors.kids && packageFormik.touched.kids) || error?.kids}
                          />
                        </Form.Group>
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                  <Row className="align-items-center pb-3">
                    <Col md={9} xs={6}>
                      <div className="f14-700 text-dark">
                        Can number of seats be customized?
                      </div>
                      <div className="f11-400 opacity5">
                        Enable this option if you want add extra PAX on top of
                        the package
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="d-flex align-items-center">
                        <div className="f12-400 mr-2">No</div>
                        <Toggle
                          checked={packageFormik.values.seatCustomized}
                          toggleFunction={() =>
                            packageFormik.setFieldValue(
                              "seatCustomized",
                              !packageFormik.values.seatCustomized
                            )
                          }
                          disabled={!formik.values.allowSingleBooking}
                        />
                        <div className="f12-400 ml-2">Yes</div>
                      </div>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="pb-3 pt-3">
                        <TextField
                          id="desc"
                          label=" Description for Package"
                          multiline
                          rows="5"
                          type="text"
                          variant="outlined"
                          className={`w-100`}
                          name="desc"
                          onChange={packageFormik.handleChange}
                          value={packageFormik.values.desc}
                          onBlur={packageFormik.handleBlur}
                          helperText={
                            packageFormik.errors.desc && packageFormik.touched.desc
                              ? packageFormik.errors.desc
                              : "*Max 500 Characters"
                          }
                          error={packageFormik.errors.desc && packageFormik.touched.desc}
                          isInvalid={packageFormik.errors.desc && packageFormik.touched.desc}
                        />
                        <div className="d-flex row my-2">
                          <div className="col-3">
                            <AddButtonIconComponent
                              buttonText="save"
                              onClick={onSave}
                              fontIcon="fa fa-plus"
                              colorCss="blue"
                            />
                          </div>
                          <div className="col-4">
                            <AddButtonIconComponent
                              buttonText="Save and Add Another"
                              onClick={onSaveAndAdd}
                              fontIcon="fa fa-plus"
                              colorCss="blue"
                            />
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              )}
              {formik.values.isPackagesProvided && (
                <>
                  <br />
                  <div
                    className="f13-500 mb-4 col-6"
                    style={{ color: "#EE3A23", cursor: "pointer" }}
                    onClick={() => {
                      setShowPackages(!showPackages);
                    }}
                  >
                    Show Added Packages{" "}
                    <i className="fa fa-chevron-up" aria-hidden="true"></i>
                  </div>
                  {showPackages && formik.values.packages.length ? (
                    formik.values.packages.map((ele) => (
                      <>
                        <AddedPackages
                          data={ele}
                          editPackage={editPackage}
                          deletePackage={deletePackage}
                          onPackageStatusChange={onPackageStatusChange}
                          ageRestriction={ageRestriction}
                        />
                      </>
                    ))
                  ) : (
                    <></>
                  )}
                </>
              )}
              {expType === "SPECIAL" && (
                <>
                  <hr />
                  <Row className="align-items-center pb-3 pl-3 w-100">
                    <Col md={9} xs={6}>
                      <div className="f14-700 text-dark">
                        Do you want to enable rescheduling for experience?
                      </div>
                      <div className="f11-400 opacity5">
                        By enabling this option user can be able to reschedule
                        experience date & time
                      </div>
                    </Col>
                    <Col md={3} xs={6}>
                      <div className="d-flex align-items-center">
                        <div className="f12-400 mr-2">No</div>
                        <Toggle
                          checked={formik.values.rescheduleAllowed}
                          toggleFunction={() =>
                            formik.setFieldValue(
                              "rescheduleAllowed",
                              !formik.values.rescheduleAllowed
                            )
                          }
                        />
                        <div className="f12-400 ml-2">Yes</div>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
              <hr />
              <div className="align-items-center pb-3 w-100 pl-3">
                <Row className="w-100">
                  <Col md={9} xs={6}>
                    <div className="f14-700 text-dark">
                      Do you want to give add-on services?
                    </div>
                    <div className="f11-400 opacity5">
                      Enable this option if you want to give additional services
                      for the experience like balloons, clown etc.
                    </div>
                  </Col>
                  <Col md={2} xs={6}>
                    <div className="d-flex align-items-center">
                      <div className="f12-400 mr-2">No</div>
                      <Toggle
                        checked={formik.values.addOnAvailable}
                        toggleFunction={() =>
                          formik.setFieldValue(
                            "addOnAvailable",
                            !formik.values.addOnAvailable
                          )
                        }
                      />
                      <div className="f12-400 ml-2">Yes</div>
                    </div>
                  </Col>
                </Row>
                {formik.values.addOnAvailable && (
                  <Col md={12} className="mt-3">
                    <Form.Group className="py-4">
                      <TextField
                        id="addOnDesc"
                        label="Add Service"
                        multiline
                        rows="5"
                        type="text"
                        variant="outlined"
                        className={`w-100 ${formik.errors.addOnDesc && formik.touched.addOnDesc ? "enError" : ""
                          }`}
                        name="addOnDesc"
                        onChange={formik.handleChange}
                        value={formik.values.addOnDesc}
                        onBlur={formik.handleBlur}
                        helperText={
                          formik.errors.addOnDesc && formik.touched.addOnDesc
                            ? formik.errors.addOnDesc
                            : "Max 500 characters"
                        }
                        error={formik.errors.addOnDesc && formik.touched.addOnDesc}
                        onInvalid={
                          formik.errors.addOnDesc && formik.touched.addOnDesc
                        }
                      />
                    </Form.Group>
                  </Col>
                )}
              </div>
              <Col md={12}>
                <Form.Group className="pb-4">
                  <TextField
                    id="refundDesc"
                    label="Refund & cancellation"
                    multiline
                    rows="5"
                    type="text"
                    variant="outlined"
                    className={`w-100 ${formik.errors.refundDesc && formik.touched.refundDesc ? "enError" : ""
                      }`}
                    name="refundDesc"
                    onChange={formik.handleChange}
                    value={formik.values.refundDesc}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.errors.refundDesc && formik.touched.refundDesc
                        ? formik.errors.refundDesc
                        : "Max 500 characters"
                    }
                    error={formik.errors.refundDesc && formik.touched.refundDesc}
                    isInvalid={
                      formik.errors.refundDesc && formik.touched.refundDesc
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};

export default ExperienceBooking;
